function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVolumeSilentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.553 5.585A1.001 1.001 0 0119 6.48v19.04a1 1 0 01-1.447.894l-7.79-3.895H4a1 1 0 01-1-1V10.48a1 1 0 011-1h5.764l7.789-3.895zM11 11.098v9.804l6 3V8.098l-6 3zm-6 9.423h4v-9.04H5v9.04zm23.707-6.77L26.457 16l2.25 2.249-1.414 1.414-2.25-2.25-2.25 2.25-1.413-1.414L23.629 16l-2.25-2.25 1.415-1.413 2.249 2.249 2.25-2.25 1.414 1.415z",
    fill: props.color
  }));
}

export default SvgIconVolumeSilentFilled;